import * as React from 'react';
import * as styles from './styles.css';
import { Image, ITypographyComponentProps, UIText2 } from '@cian/ui-kit';

interface IChartInfoItem {
  src: string;
  text: string;
  color: ITypographyComponentProps['color'];
}
export function ChartItemInfo({ src, text, color }: IChartInfoItem) {
  return (
    <div className={styles['container']}>
      <div className={styles['img']}>
        <Image src={src} />
      </div>
      <UIText2 fontWeight="400" color={color}>
        {text}
      </UIText2>
    </div>
  );
}
